// @copyright  2006-2024 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/finance/other-income',
        component: () =>
            import('@/pages/[organisation]/finance/other-income.vue'),
        name: 'finance.other-income.search-other-income',
        meta: {
            loginRequired: true,
            permission: 'access.finance.other-income.view-other-incomes',
        },
        children: [
            {
                path: 'create',
                component: () =>
                    import('@/pages/[organisation]/finance/other-income/create.vue'),
                name: 'finance.other-income.create-other-income',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.other-income.create-other-income',
                },
            },
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/finance/other-income/[id].vue'),
                name: 'finance.other-income.view-other-income',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.other-income.view-other-income',
                },
                children: [
                    {
                        path: 'new-payment',
                        component: () =>
                            import(/* webpackChunkName: "finance.other-income" */ '@/pages/[organisation]/finance/other-income/other-income-payment/new.vue'),
                        name: 'finance.other-income.create-other-income-payment',
                        meta: {
                            loginRequired: true,
                            permission: 'access.finance.other-income.create-other-income-payment',
                        },
                    },
                ],
            },
            {
                path: ':id/other-income-payments',
                component: () =>
                    import(/* webpackChunkName: "finance.other-income" */ '@/pages/[organisation]/finance/other-income/[id]/other-income-payments.vue'),
                name: 'finance.other-income.search-other-income-payments',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.other-income.view-other-income',
                },
            },
            {
                path: ':id/edit-draft',
                component: () =>
                    import('@/pages/[organisation]/finance/other-income/[id]/edit-draft.vue'),
                name: 'finance.other-income.update-draft-other-income',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.other-income.update-other-income',
                },
            },
        ],
    },
];
